export const fiatCurrencies = [
  { slug: 'aud', name: 'Australian Dollar' },
  { slug: 'brl', name: 'Brazilian Real' },
  { slug: 'cad', name: 'Canadian Dollar' },
  { slug: 'chf', name: 'Swiss Franc' },
  { slug: 'cny', name: 'Chinese Renminbi Yuan' },
  { slug: 'dkk', name: 'Danish Krone' },
  { slug: 'eur', name: 'Euro' },
  { slug: 'gbp', name: 'British Pound' },
  { slug: 'hkd', name: 'Hong Kong Dollar' },
  { slug: 'ils', name: 'Israeli New Sheqel' },
  { slug: 'inr', name: 'Indian Rupee' },
  { slug: 'jpy', name: 'Japanese Yen' },
  { slug: 'krw', name: 'South Korean Won' },
  { slug: 'mxn', name: 'Mexican Peso' },
  { slug: 'myr', name: 'Malaysian Ringgit' },
  { slug: 'nok', name: 'Norwegian Krone' },
  { slug: 'nzd', name: 'New Zealand Dollar' },
  { slug: 'pln', name: 'Polish Złoty' },
  { slug: 'rub', name: 'Russian Ruble' },
  { slug: 'sgd', name: 'Singapore Dollar' },
  { slug: 'sek', name: 'Swedish Krona' },
  { slug: 'thb', name: 'Thai Baht' },
  { slug: 'try', name: 'Turkish Lira' },
  { slug: 'usd', name: 'United States Dollar' },
  { slug: 'zar', name: 'South African Rand' },
];

export const fiatCurrenciesSlug = [
  'aud',
  'brl',
  'cad',
  'chf',
  'cny',
  'dkk',
  'eur',
  'gbp',
  'hkd',
  'ils',
  'inr',
  'jpy',
  'krw',
  'mxn',
  'myr',
  'nok',
  'nzd',
  'pln',
  'rub',
  'sgd',
  'sek',
  'thb',
  'try',
  'usd',
  'zar',
];
